import axios from "axios";
import { ENDPOINT_AUTH, ENDPOINT_LOAD_SESSION, ENDPOINT_LOGOUT } from "../../constants";

export async function authorize(code:string,com:string) : Promise<any> {
    //console.log(code, com)
    const res = await axios.post(ENDPOINT_AUTH, {
        code:code,
        com:com
    },{withCredentials:true});
    console.log("Authorizing...", res.data)
    return res.data
}

export async function loadSession() : Promise<any> {
    const res = await axios.get(ENDPOINT_LOAD_SESSION, {withCredentials:true});
    console.log("load session...", res.data)  
    return res.data
}

export async function logout() : Promise<string> {
    const res = await axios.post(ENDPOINT_LOGOUT, {}, {withCredentials:true});
    console.log("Authorizing...", res.data)
    if (res.data.Code !== 200 )
        throw new Error(res.data.Code)
    
    return res.data.Msg
}